export default "__VITE_ASSET__DOx_cXKf__"